<!-- <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"> -->

<footer class=" text-lg-start text-muted" style="background-color: #fff;">

  <!-- Section: Social media -->

  <!-- Section: Links  -->

  <div class=container>
    <!-- Copyright -->
    <div class="text-center pt-3 footer-copyright">
      <p class="title">© 2026 GTN Group Holding Ltd. All rights reserved.</p>
      <p>
        GTN API and FIX documentation are provided for informational and integration purposes only. GTN API and FIX
        services are offered on an "as-is" and "as-available" basis.
      </p>
      <p>
        GTN makes no representations or warranties of any kind, whether express, implied, statutory, or otherwise,
        including but not limited to, regarding the accuracy, reliability, availability, or functionality of the API,
        FIX services, or related documentation.
      </p>
      <p>
        Users must ensure compliance with all relevant laws and regulations, and GTN shall not be liable for any direct
        or indirect losses, or damages or claims arising from the use of GTN API and FIX services and/or documentation.
      </p>
      <p>
        In the Americas region, GTN technology infrastructure, including the Developer Portal, is provided through GTN
        Market Data Services Ltd, a company registered in the United Kingdom (registration number: 13863834).
      </p>
      <p>
        GTN Market Data Services Ltd is a wholly owned subsidiary of GTN Group Holding Ltd and is not a registered
        broker-dealer.
      </p>
    </div>
  </div>

  <div *ngIf="userType === 'FEED'">
    <section class="pt-2">
      <div class="container text-center text-md-start mt-5">
        <!-- Grid row -->

        <div class="row mt-3">

          <!-- Grid column -->
          <div class="col-md-8 col-lg-8 col-xl-8 mx-auto mb-4">
            <h6 class="text-uppercase fw-bold mb-4">
              Disclaimer
            </h6>
            <p>Neither Global Market Access Network (DIFC) Limited (“GTN”), its affiliates, nor the information
              provider/s shall be liable to the user or any other person, regardless of the cause for any errors,
              inaccuracies or omissions of the information, for any delay or interruption, for any claims or losses
              arising therefrom. GTN now disclaims all liability for losses or damages of any kind whether direct or
              indirect, consequential, compensatory, actual, punitive, special, incidental, or exemplary, arising out of
              the use of the site or the reference and reliance on any information obtained on the site. </p>
          </div>


          <!-- Grid column -->
          <div class="col-md-4 col-lg-4 col-xl-4 mx-auto mb-4">
            <!-- Links -->
            <h6 class="text-uppercase fw-bold mb-4">
              Contacts
            </h6>
            <table>

              <tr>
                <td><i class="fa fa-envelope me-3" aria-hidden="true"></i></td>
                <td>
                  <p>For Support: feed.ops&#64;gtngroup.com</p>
                </td>
              </tr>
              <tr>
                <td><i class="fa fa-envelope me-3" aria-hidden="true"></i></td>
                <td>
                  <p>For Clarifications: feedservices&#64;gtngroup.com</p>
                </td>
              </tr>
            </table>
          </div>


        </div>
        <!-- Grid row -->
      </div>
    </section>
    <!-- Section: Links  -->


    <!-- Copyright -->
    <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2);">
      © 2023 Copyright:
      <a class="text-dark" href="#">Global Market Access Network (DIFC) Limited. All Rights Reserved.</a>
    </div>
  </div>
  <!-- Copyright -->
</footer>
